var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotPolygon = function SvgHotspotPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    stroke: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeMiterlimit: 3.999,
    d: "m15.027 12.256-.042-6.038M4.813 3.111l8.854 1.408M3.012 13.195v-8.44M4.938 14.846l8.443-1.303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    d: "M4.565 15.08a1.552 1.552 0 1 1-3.105 0 1.552 1.552 0 0 1 3.105 0ZM16.538 13.605a1.552 1.552 0 1 1-3.105 0 1.552 1.552 0 0 1 3.105 0ZM16.538 4.425a1.552 1.552 0 1 1-3.105 0 1.552 1.552 0 0 1 3.105 0ZM4.565 2.922a1.552 1.552 0 1 1-3.104 0 1.552 1.552 0 0 1 3.104 0Z"
  })));
};
export default SvgHotspotPolygon;